import { client } from './client';

export const getAppConfig = (configId: string) =>
  client(`app-config/${configId}`, {
    method: 'GET'
  });
